import Appwrite from 'appwrite'
import { useContext } from 'react'
import { AppwriteContext } from '../appwriteContext'

const useAppwrite = (): Appwrite => {
    return useContext(AppwriteContext)
};

export default useAppwrite;
